import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { fieldTypes } from '../../../../constants/constant';
import has from 'lodash/has';
import type { Fields } from '../../model/formBuilderInterface';
@Component({
  selector: 'app-dynamic-form-builder',
  templateUrl: './dynamic-form-builder.component.html',
  styleUrls: ['./dynamic-form-builder.component.scss']
})
export class DynamicFormBuilderComponent {
  @Input() fields: Fields;
  @Input() form: FormGroup;
  @Input() isEditMode = false;
  readonly fieldTypesEnum = fieldTypes;

  @Output() handleFormSubmit: EventEmitter<void> = new EventEmitter<void>();

  onSubmit() {
    this.handleFormSubmit.emit();
  }

  isFieldVisible(field) {
    return !has(field, 'visible') || field.visible;
  }

  onSegmentEmbedMapInteraction(data: { lat?: number; long?: number; radius?: number }, fieldName: string): void {
    if (!data) {
      return;
    }
    this.form.get(fieldName)?.setValue(data);
  }
}
